export const UnifiedPayApi = 'wx/wxpay/' // 统一支付部分

